import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { AiButton } from '../../../../assets/common';
import { homepage_icon, illustration_contribution } from '../../../../assets/img';
import { BreadCrumb } from '../../../../components';
import { useSearchParams } from '../../../../hooks/useSearchQuery';
import { AiDesc, AiTitle, Container, ContainerTitle, Row } from './Styled';

const itemIncumbent = {
  title: 'Great! You have concluded the Meeting!',
  desc: 'Meeting has been conclude and the finalized MOM can be viewed in the completed meeting list page in PDC Meeting. Thank you!',
  btnCancel: 'Back to Home',
  borderCancel: true,
  modeCancel: '',
  img: illustration_contribution,
};
const ConcludePDCMeeting = () => {
  const history = useHistory();
  const meeting = useSelector((state) => state.app.meetingModule.preMeeting.meeting);
  const [breadCrumbList, setBreadCrumbList] = useState([{ name: 'PDC Meeting', icon: homepage_icon }, { name: 'Board Management Meeting' }]);
  const { meeting_name } = useSearchParams();

  useEffect(() => {
    setBreadCrumbList([{ name: 'Homepage', icon: homepage_icon, url: '/' }, { name: 'PDC Meeting', url: '/pdc' }, { name: meeting_name || '' }]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meeting && meeting_name]);

  return (
    <>
      <div style={{ marginLeft: '20px' }}>
        <BreadCrumb level={3} breadCrumbList={breadCrumbList} />
      </div>
      <ContainerTitle>{meeting_name || ''}</ContainerTitle>
      <Container>
        <Row style={{ gap: '70px' }}>
          <div>
            <AiTitle style={{ width: '460px' }}>{itemIncumbent.title}</AiTitle>
            <AiDesc style={{ width: '290px' }}>
              {itemIncumbent.desc}
              <br />
            </AiDesc>
            <AiButton border={itemIncumbent?.borderCancel} mode={itemIncumbent.modeCancel} onClick={() => history.push('/homepage')}>
              {itemIncumbent.btnCancel}
            </AiButton>
          </div>
          <div>
            <img src={itemIncumbent.img} alt="" />
          </div>
        </Row>
      </Container>
    </>
  );
};
export default ConcludePDCMeeting;
